<template>
	<div class="question-container">
		<div>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div class="input-text">
				<div
					:style="{
						color: v$.textValue.$invalid ? theme.errorInputAccentColor : theme.mainTextColor,
					}"
				>
					<!--<InputPhone v-model:saturn="textValue"
                                :invalid="v$.textValue.$invalid"
                                type="tel"
                                maxlength="10"
                                minlength="10">
                    </InputPhone>-->
					<InputMasked
						:onkeypress="data.question.onKeyPressMethod ? util[data.question.onKeyPressMethod]() : util.getOnkeypressNumbersOnlyFormat()"
						:saturn="textValue"
						type="tel"
						:invalid="v$.textValue.$invalid"
						mask="+1 (XXX) XXX-XXXX"
						:minlength="data.question.minLength"
						:maxlength="data.question.maxLength"
						@input="e => handleInput(e, 'textValue')"
						@keyEnter="continueToNextQuestion(isValid)"
					/>
					<!--:autofocus="textValue ? false : true" />-->
				</div>
			</div>
		</div>
		<div class="question-continue-button">
			<button
				class="button"
				:style="{
					background: theme[answer.style.background],
					color: theme[answer.style.text],
				}"
				@click="answer.actions(textValue, [], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!data.question.isValidationsMet(answer, v$.textValue)"
			>
				{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
			</button>
		</div>
	</div>
</template>

<script>
	import util from '@core/services/util';
	import InputMasked from '@/components/customerApp/InputMasked.vue';
	import { required, minLength, numeric, maxLength, between } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'QuestionInputPhone',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				answer: {},
				textValue: null,
			};
		},
		computed: {
			util() {
				return util;
			},
			isValid() {
				return this.data.question.isValidationsMet(this.answer, this.v$.textValue);
			},
		},
		created() {
			this.answer = this.data.question.getAnswers()[0];
			this.textValue = this.data.question.savedAnswer;
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
				},
				{ deep: true },
			);
		},

		validations() {
			if (this.data.question.GetValidation) {
				return this.data.question.GetValidation();
			}
		},
		methods: {
			handleInput(value, variable) {
				this[variable] = value;
			},
			continueToNextQuestion(isValid) {
				if (isValid) {
					this.answer.actions(this.textValue.trim(), [], this.data.question, this.toggleLoading);
				}
			},
		},
		components: {
			InputMasked,
		},
	};
</script>

<style></style>
